import * as React from "react";
const SvgFiRrUserShield = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-user-shield_svg__a)">
      <path
        fill="#062147"
        d="M10.958 15.576a.995.995 0 0 1-1.244.673A6.006 6.006 0 0 0 2 22v1a1 1 0 1 1-2 0v-1c0-4.411 3.589-8 8-8 .778 0 1.548.112 2.286.332a1 1 0 0 1 .672 1.244M24 14.436v3.085c0 4.032-3.973 5.942-5.126 6.406a1 1 0 0 1-.836-.041C16.915 23.324 13 21.09 13 17.521v-3.085c0-1.295.826-2.439 2.055-2.848l3.131-1.038a1 1 0 0 1 .629 0l3.13 1.038A3 3 0 0 1 24 14.436m-2 0a1 1 0 0 0-.686-.949l-2.814-.933-2.815.933a1 1 0 0 0-.685.949v3.085c0 2.28 2.63 3.888 3.545 4.379C19.576 21.446 22 20.104 22 17.521zM14 6c0 3.309-2.691 6-6 6S2 9.309 2 6s2.691-6 6-6 6 2.691 6 6m-2 0c0-2.206-1.794-4-4-4S4 3.794 4 6s1.794 4 4 4 4-1.794 4-4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-user-shield_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUserShield;
